import type React from 'react';

import { Button, type ButtonProps, type IconDefinition } from '@gitbook/spine-react';

interface InsertValueButtonProps {
    label: string;
    active: boolean;
    buttonRef: React.RefObject<HTMLButtonElement>;
    leadingIcon: IconDefinition;
    onPress: () => void;
    onKeyDown?: (event: React.KeyboardEvent<HTMLButtonElement>) => void;
    tooltip?: ButtonProps['tooltip'];
}

export function InsertValueButton({
    label,
    active,
    buttonRef,
    leadingIcon,
    onPress,
    onKeyDown,
    tooltip,
}: InsertValueButtonProps) {
    return (
        <Button
            label={label}
            ref={buttonRef}
            leadingIcon={leadingIcon}
            active={active}
            onPress={onPress}
            onKeyDown={onKeyDown}
            iconOnly
            kind="secondary"
            size="small"
            className="-translate-y-1/2 absolute top-1/2 right-0"
            tabIndex={0}
            tooltip={tooltip}
        />
    );
}
